// Razorpay Checkout helper
// Loads the Razorpay JS SDK once, then opens the Checkout modal for a given subscription_id

import { http, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const SCRIPT_SRC = "https://checkout.razorpay.com/v1/checkout.js";

function loadScript() {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return resolve(true);
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Failed to load Razorpay checkout"));
    document.body.appendChild(s);
  });
}

export async function startRazorpaySubscription(catalogueKey, { seats, onSuccess } = {}) {
  try {
    await loadScript();
    const reqBody = { catalogue_key: catalogueKey };
    // Per-seat plans (institute_growth_perseat / institute_enterprise_perseat) require
    // the seat count to be passed so the server multiplies the per-seat base price by
    // quantity on the Razorpay subscription. Flat plans omit `seats` entirely.
    if (typeof seats === "number" && Number.isFinite(seats) && seats > 0) {
      reqBody.seats = seats;
    }
    const { data } = await http.post("/razorpay/create-subscription", reqBody);
    const options = {
      key: data.razorpay_key_id,
      subscription_id: data.subscription_id,
      name: "VidyaAI Study",
      description: data.label,
      image: "/logo192.png",
      prefill: { name: data.user_name, email: data.user_email },
      theme: { color: "#C24933" },
      handler: async (response) => {
        try {
          const v = await http.post("/razorpay/verify-payment", {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_subscription_id: response.razorpay_subscription_id,
            razorpay_signature: response.razorpay_signature,
          });
          toast.success("Subscription activated! 🎉");
          if (onSuccess) onSuccess(v.data);
        } catch (e) {
          toast.error(formatApiError(e));
        }
      },
      modal: { ondismiss: () => toast.info("Payment cancelled") },
    };
    const rzp = new window.Razorpay(options);
    rzp.on("payment.failed", (resp) => {
      toast.error(`Payment failed: ${resp.error?.description || "Unknown error"}`);
    });
    rzp.open();
  } catch (e) {
    toast.error(formatApiError(e));
  }
}
